var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"sidebar z-30 flex-shrink-0 hidden lg:block w-64 h-full overflow-y-auto bg-white"},[_c('sidebar-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }